import { createAction } from 'redux-actions'
import { updateVisit, updateRoom } from '../actions'
import { populateFormErrors } from '../modules/errorDialogModule'

export const changeDates = createAction('CHANGE_DASHBOARD_DATES')
export const changeSearchText = createAction('CHANGE_DASHBOARD_SEARCH_TEXT')
export const changeProgramRoomVisibility = createAction(
  'CHANGE_DASHBOARD_PROGRAM_ROOM_VISIBILITY'
)

export const closeVisitDialog = createAction('CLOSE_DASHBOARD_VISIT_DIALOG')
export const openVisitDialog = createAction('OPEN_DASHBOARD_VISIT_DIALOG')
export const changeVisitDialogValue = createAction(
  'CHANGE_DASHBOARD_VISIT_DIALOG_VALUE'
)
export const saveVisitDialogSuccess = createAction(
  'SAVE_DASHBOARD_VISIT_DIALOG_SUCCESS'
)

export const closeRoomDialog = createAction('CLOSE_DASHBOARD_ROOM_DIALOG')
export const openRoomDialog = createAction('OPEN_DASHBOARD_ROOM_DIALOG')
export const changeRoomDialogValue = createAction(
  'CHANGE_DASHBOARD_ROOM_DIALOG_VALUE'
)
export const saveRoomDialogSuccess = createAction(
  'SAVE_DASHBOARD_ROOM_DIALOG_SUCCESS'
)

export function saveVisitDialog(edits) {
  return (dispatch, getState) => {
    let state = getState()

    if (edits.checkedIn !== undefined) {
      let promises = []
      let visitId = state.dashboard.dialogs.visit.visitId
      let updateObj = { id: visitId }
      if (edits.checkedIn) {
        updateObj.checkedIn = true
      } else {
        updateObj.checkedOut = true
      }
      promises.push(dispatch(updateVisit(updateObj)))

      // Mark room as dirty when someone checks out
      if (edits.checkedIn === false && edits.markRoomDirty !== false) {
        let roomId = state.visits[visitId].roomId
        promises.push(
          dispatch(
            updateRoom({
              id: roomId,
              isClean: false
            })
          )
        )
      }

      Promise.all(promises).then(
        () => dispatch(saveVisitDialogSuccess()),
        error => {
          dispatch(populateFormErrors({ messages: ['Error updating visit'] }))
          console.log('Error updating visit', error)
        }
      )
    }
  }
}

export function saveRoomDialog(edits) {
  return (dispatch, getState) => {
    let roomId = getState().dashboard.dialogs.room.roomId
    if (edits.isClean !== undefined) {
      return dispatch(
        updateRoom({
          id: roomId,
          isClean: edits.isClean
        })
      ).then(() => dispatch(saveRoomDialogSuccess()))
    }
  }
}



// WEBPACK FOOTER //
// ./src/redux/actions/dashboardActions.js